/**
 * What the goodbye page (/auth/deleted) says after Delete account, handed
 * from the dialog to the page it navigates to. Module memory only, like
 * lib/authEmail: never the URL (a link to the page must not show it) nor
 * storage. One-shot — reading takes it — so the page shows once: a reload,
 * or coming back to it through the history, finds nothing and goes to
 * sign-in. A count and no names: the page is a signed-out one.
 */
export interface Farewell {
  /** How many servers the account owned; 0 leaves the servers line out. */
  ownedServers: number;
}

let pending: Farewell | null = null;

export function markFarewell(farewell: Farewell): void {
  pending = farewell;
}

/** Whether a goodbye is waiting to be shown, without taking it: what tells
 * routes/_authed that the session just ended with its account, so a tab on
 * its way to the goodbye page is not sent to sign-in instead. */
export function farewellPending(): boolean {
  return pending !== null;
}

export function readFarewell(): Farewell | null {
  const farewell = pending;
  pending = null;
  return farewell;
}
